export default __webpack_public_path__ + "static/media/mmpartners-wb-min.a73307e7.png";